module.exports = "/assets/data/4ee8ccd86c941efa91098e133dba8d2e-LA12.data.json";